<template>
  <video
    autoplay
    playsinline
    loop
    poster="@/assets/b.mp4"
    class="videoBG"
    preload="auto"
    muted
  >
    <source src="@/assets/b.mp4" type="video/mp4" />
  </video>
  <router-view />
</template>

<style lang="scss">
html {
  height: 100%;
  width: 100%;
}
.videoBG {
  //position: fixed;
  //bottom: 0;
  //left: 50%;
  //transform: translateX(-50%);
  //width: 100%;
  //height: 30%;
  //object-fit: cover;
  //z-index: -1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 130%;
  object-fit: cover;
  z-index: -10;
  transform: translateZ(0);
  backface-visibility: hidden;
}
body {
  //background-image: url("https://t7.baidu.com/it/u=3713375227,571533122&fm=193&f=GIF");
  background-image: url("assets/login_bg2.png");
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: bottom;
  margin: 0;
  padding: 0;
  height: 100%;
}
#app {
  margin: auto;
  padding: 0px;
  height: 100%;
  width: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
